// Add to Home Screen (#86bcd131r). Since #86bcp2tqv (David, 2026-10-21: no way into the new UI for end users until it
// is ready) the app opened from a phone's home screen starts in classic: public/manifest.json's start_url is "/", and an
// app installed earlier keeps its old start address, "/?source=homescreen#/", which this turns into classic's. The
// entry switch (src/index.js) puts the address this returns in place before it chooses an app, so neither the marker
// nor its "#/" stays in the address. A full new-UI address ("/#/login", "/#/demo") still opens the new UI, in an app
// window too, and so does a marked launch at one: the demo's own icon (the sandbox's manifest) starts at
// "/?source=homescreen#/demo", and keeps opening the show's demo.
// Returns that address, or null when this isn't a home-screen launch. The path keeps one leading slash: "//host" or
// "/\host" would name another site, which history.replaceState refuses.
export function homeScreenLaunch({ pathname, search, hash }) {
  const params = new URLSearchParams(search)
  if (params.get('source') !== 'homescreen') return null
  params.delete('source')
  const rest = params.toString()
  const path = '/' + String(pathname).replace(/^[/\\]+/, '')
  // a route past the bare "#/" is a full new-UI address; the bare "#/" (the old start) or no route is classic's.
  // #86bcp10r8 (Ryan's notes on #86bcp2tqv): a route names a screen, so the first character after "#/" is a path's: "#/?x=1"
  // (the bare "#/" with a query), "#/#x" and "#//x" name none and are classic's too (no real install uses them)
  const route = /^#\/[^/?#]/.test(hash) ? hash : ''
  return `${path}${rest ? `?${rest}` : ''}${route}`
}
